"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Company;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const Screen_1 = __importDefault(require("../components/Screen"));
const ThemeContext_1 = require("../ThemeContext");
const native_1 = require("@react-navigation/native");
const UserContext_1 = require("../contexts/UserContext");
const cancelable_promise_1 = require("cancelable-promise");
const BenefitRenewal_1 = __importDefault(require("../api/BenefitRenewal"));
const OpenEnrollmentCard_1 = __importDefault(require("../partials/OpenEnrollmentCard"));
const BenefitRenewalDocumentSummaryCard_1 = __importDefault(require("../partials/BenefitRenewalDocumentSummaryCard"));
const BenefitRenewalDocumentCard_1 = __importDefault(require("../partials/BenefitRenewalDocumentCard"));
const native_2 = require("@react-navigation/native");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
function Company(props) {
    const THEME = (0, ThemeContext_1.useTheme)();
    const navigation = react_1.default.useContext(native_1.NavigationContext);
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size, columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [status, setStatus] = react_1.default.useState(null);
    const [refreshing, setRefreshing] = react_1.default.useState(false);
    const [benefitRenewal, setBenefitRenewal] = react_1.default.useState(null);
    const [benefitRenewalSigning, setBenefitRenewalSigning] = react_1.default.useState(null);
    const promiseRenewal = react_1.default.useRef(null);
    const promiseSigning = react_1.default.useRef(null);
    const isFocused = (0, native_2.useIsFocused)();
    const onRefresh = react_1.default.useCallback(() => {
        setRefreshing(true);
        refresh().then(() => setRefreshing(false));
        return () => {
            promiseRenewal.current?.cancel();
            promiseSigning.current?.cancel();
        };
    }, []);
    const refresh = react_1.default.useCallback(async () => {
        promiseRenewal.current?.cancel();
        promiseSigning.current?.cancel();
        setStatus('loading');
        promiseRenewal.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => BenefitRenewal_1.default.getBenefitRenewal(token)));
        promiseSigning.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => BenefitRenewal_1.default.getBenefitRenewalSigning(token)));
        Promise.all([
            promiseRenewal.current,
            promiseSigning.current
        ]).then(([renewal, signing]) => {
            var renewalResponse = renewal;
            var signingResponse = signing;
            setBenefitRenewal(renewalResponse);
            setBenefitRenewalSigning(signingResponse);
            setStatus('done');
        }).catch(e => {
            setStatus(e == 404 ? 'done' : 'error');
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promiseRenewal.current?.cancel();
            promiseSigning.current?.cancel();
        };
    }, [isFocused]);
    const cardMargin = (size == 'sm' ? 8 : 16);
    const portalEnabled = userContext?.adminExperience == 'both' ||
        userContext?.adminExperience == 'elevate-edge';
    return ((0, jsx_runtime_1.jsxs)(Screen_1.default, { onRefresh: onRefresh, refreshing: refreshing, containerStyle: (portalEnabled && size != 'sm') ? {
            backgroundColor: THEME.CardBackground,
            padding: 0
        } : { padding: 0 }, scrollStyle: (portalEnabled && size != 'sm') ? {
            backgroundColor: THEME.CardBackground
        } : null, children: [!portalEnabled &&
                (0, jsx_runtime_1.jsx)(react_native_1.Image, { resizeMode: 'cover', source: size != 'sm' ? Theme_1.IMAGES.RenewalBackgroundWeb : Theme_1.IMAGES.RenewalBackground, style: { width: '100%', height: 'auto', aspectRatio: size != 'sm' ? 11.2 : 5.6, marginTop: size != 'sm' ? 12 : 4, borderRadius: size != 'sm' ? 4 : 0 } }), size != 'sm'
                &&
                    (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                            margin: (portalEnabled ? (columns > 1 ? cardMargin : 0) : (columns > 1 ? -cardMargin : 0)),
                            marginTop: (portalEnabled ? (columns > 1 ? cardMargin : 0) : cardMargin)
                        }, children: [!!benefitRenewalSigning?.isSigner && !benefitRenewalSigning?.documentSignedDate && (0, jsx_runtime_1.jsx)(BenefitRenewalDocumentSummaryCard_1.default, { navigation: navigation }), (benefitRenewal?.status == "Open Enrollment" || !!benefitRenewalSigning?.documentSignedDate) && (0, jsx_runtime_1.jsx)(OpenEnrollmentCard_1.default, { benefitRenewal: benefitRenewal, status: status, navigation: navigation }), !!benefitRenewalSigning?.isSigner && (0, jsx_runtime_1.jsx)(BenefitRenewalDocumentCard_1.default, { benefitRenewalSigning: benefitRenewalSigning, status: status, navigation: navigation })] })
                ||
                    (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginBottom: 3 }, children: [!!benefitRenewalSigning?.isSigner && (0, jsx_runtime_1.jsx)(BenefitRenewalDocumentCard_1.default, { benefitRenewalSigning: benefitRenewalSigning, status: status, navigation: navigation }), !!benefitRenewalSigning?.isSigner && !benefitRenewalSigning?.documentSignedDate && (0, jsx_runtime_1.jsx)(BenefitRenewalDocumentSummaryCard_1.default, { navigation: navigation }), (benefitRenewal?.status == "Open Enrollment" || !!benefitRenewalSigning?.documentSignedDate) && (0, jsx_runtime_1.jsx)(OpenEnrollmentCard_1.default, { benefitRenewal: benefitRenewal, status: status, navigation: navigation })] })] }));
}
